export const redBgClass = 'bg-danger';
export const blueBgClass = 'bg-global';
export const yellowBgClass = 'bg-warning';
export const pinkRoseBgClass = 'bg-pink_rose';
export const badgeGlobalSecondary = 'bg-global-700';

export const LOGIN_USER_MSG = 'LOGIN_USER_MSG';

export class BaseMessage {
	date: Date;
	body: string;
	id: string;
	messageId: string;
	title: string;
	type: MessageTypes;
	isRead: boolean;
	createDateTime: Date;
	isEnabled: boolean;
	isins?: string[];
	contentType: any;
}
export class MarketMessage extends BaseMessage {
	isToday: boolean;
	isSeen: boolean;
}

export class MofidMessage extends BaseMessage {
	imageId?: string;
	url?: string;
	route?: string;
}

export class LsMessage {
	Id: string;
	Timestamp: string;
	Body: string;
	MessageId: string;
	Title: string;
	Type: any;
	Isin: string;
	IsEnabled?: boolean;
}

export class UpdateMessage {
	messageIds: string[];
}

export class SendCustomMessage {
	messageTitle: string;
	messageContent: string;

	constructor(title: string, content: string) {
		this.messageContent = content;
		this.messageTitle = title;
	}
}

export class BrokerMessageResult {
	isSuccessful: boolean;
	totalRecord: number;
	messages: BrokerMessage[];
}

export class BrokerMessage {
	id: number;
	title: string;
	body: string;
	isRead: boolean;
	readDate: Date;
	sendDate: Date;
}

export interface TextMessageFilter {
	type?: MessageTypes;
	from?: Date;
	to?: Date;
	isin?: string;
}

export enum MessageContentTypes {
	ArzeAvalie = 1,
	Goshayesh,
	TavaghofNamad,
	PazireNevisi,
	DamaneMojaz,
	Omde,
	SarResid,
	BazGoshayi,
	Ettelaeeye,
	Bazargardani,
	Haraj,
	RafeeGere,
	Other = 1000,
	EstefadeNashode,
	Maskan,
	Energy,
	NotConfirm,
	Codal,
	Mofid
}

export enum MessageTypes {
	MarketMessage = 0,
	ImmediateMessage = 1,
	LoginMessage = 2,
	MofidMessage = 3,
	UserMessage = 4,
	CodalMessage = 5
}

export enum MessagesCategory {
	MarketMessages,
	PortfolioMessage,
	immediateBrokerMessages,
	MofidMessages
}

export type MessageNotification = {
	isin?: string;
	messageType: string;
	title: string;
	body?: string;
};
export interface NotifiedMessages {
	date: Date;
	notifiedMessageIds: string[]; // notified message Ids (for portfolio, order and draft stocks' messages)
}
export type MessageType = { state: string; count?: number };
export type MessageImage = { imageId: string; data: string | ArrayBuffer };
export const typeExtractor: { [id: string]: MessageContentTypes } = {
	'عرضه اولیه': MessageContentTypes.ArzeAvalie,
	'گشایش ': MessageContentTypes.Goshayesh,
	'توقف ': MessageContentTypes.TavaghofNamad,
	'پذیره نویسی': MessageContentTypes.PazireNevisi,
	'دامنه مجاز': MessageContentTypes.DamaneMojaz,
	'عمده ': MessageContentTypes.Omde,
	'سررسید ': MessageContentTypes.SarResid,
	'بازگشایی ': MessageContentTypes.BazGoshayi,
	'اطلاعیه ': MessageContentTypes.Ettelaeeye,
	'بازارگردانی ': MessageContentTypes.Bazargardani,
	'حراج ': MessageContentTypes.Haraj,
	'رفع گره': MessageContentTypes.RafeeGere,
	'استفاده نشده': MessageContentTypes.EstefadeNashode,
	'مسکن ': MessageContentTypes.Other,
	'بورس انرژی ': MessageContentTypes.Energy,
	'عدم تایید ': MessageContentTypes.NotConfirm
};

export const messageIcon: { [key in MessageContentTypes]: string } = {
	[MessageContentTypes.ArzeAvalie]: 'mdi-play-circle text-success',
	[MessageContentTypes.Goshayesh]: 'mdi-play-circle text-success',
	[MessageContentTypes.TavaghofNamad]: 'mdi-stop-circle text-danger',
	[MessageContentTypes.PazireNevisi]: 'mdi-play-circle text-success',
	[MessageContentTypes.DamaneMojaz]: 'mdi-play-circle text-success',
	[MessageContentTypes.Omde]: 'mdi-dots-horizontal-circle text-secondary',
	[MessageContentTypes.SarResid]: 'mdi-stop-circle text-danger',
	[MessageContentTypes.BazGoshayi]: 'mdi-play-circle text-success',
	[MessageContentTypes.Ettelaeeye]: 'mdi-play-circle text-success',
	[MessageContentTypes.Bazargardani]: 'mdi-play-circle text-success',
	[MessageContentTypes.Haraj]: 'mdi-play-circle text-success',
	[MessageContentTypes.RafeeGere]: 'mdi-skip-next-circle text-secondary',
	[MessageContentTypes.Other]: 'mdi-dots-horizontal-circle text-secondary',
	[MessageContentTypes.EstefadeNashode]: 'mdi-alert-circle text-secondary',
	[MessageContentTypes.Energy]: 'mdi-fire-circle text-info',
	[MessageContentTypes.NotConfirm]: 'mdi-cancel text-danger',
	[MessageContentTypes.Maskan]: 'mdi-home-circle text-secondary',
	[MessageContentTypes.Codal]: 'mdi-codal text-primary-600',
	[MessageContentTypes.Mofid]: 'mdi-mofid text-global'
};

export const messageIconBackgroundClass: { [key in MessageContentTypes]: string } = {
	[MessageContentTypes.ArzeAvalie]: 'bg-success',
	[MessageContentTypes.Goshayesh]: 'bg-success',
	[MessageContentTypes.TavaghofNamad]: 'bg-danger',
	[MessageContentTypes.PazireNevisi]: 'bg-success',
	[MessageContentTypes.DamaneMojaz]: 'bg-success',
	[MessageContentTypes.Omde]: ' bg-secondary',
	[MessageContentTypes.SarResid]: 'bg-danger',
	[MessageContentTypes.BazGoshayi]: 'bg-success',
	[MessageContentTypes.Ettelaeeye]: 'bg-success',
	[MessageContentTypes.Bazargardani]: 'bg-success',
	[MessageContentTypes.Haraj]: 'bg-success',
	[MessageContentTypes.RafeeGere]: ' bg-secondary',
	[MessageContentTypes.Other]: ' bg-secondary',
	[MessageContentTypes.EstefadeNashode]: ' bg-secondary',
	[MessageContentTypes.Energy]: 'bg-info',
	[MessageContentTypes.NotConfirm]: 'bg-danger',
	[MessageContentTypes.Maskan]: 'bg-secondary',
	[MessageContentTypes.Codal]: 'bg-primary',
	[MessageContentTypes.Mofid]: 'bg-global'
};

export interface PortfolioOrderDraftIsins {
	portfolioIsins: string[];
	omsOrderIsins: string[];
	draftIsins: string[];
}

export interface NotifiedMessages {
	date: Date;
	notifiedMessageIds: string[]; // notified message Ids (for portfolio, order and draft stocks' messages)
}
export interface PageState {
	pageSize: number;
	pageNo: number;
}

export interface MofidMessagesInput extends PageState {
	symbolIsin?: string;
}
